module.exports = __webpack_public_path__ + "img/wave-bottom-with-dots.587e659b.svg";